import React, { useEffect, useState } from "react";
import Filter from "../../../../assets/Icons/filter.png";
import ExcelExport from "../../../../compnenets/commons/xls";
import Modal from "react-responsive-modal";
import Close from "../../../../assets/Images/close.png";
import leftArrow from "../../../../assets/Images/left-arrow.png";
import rightArrow from "../../../../assets/Images/right-arrow.png";
import "../archival.css";
import { PROJECT_ARCHIVAL } from "../../../../services/apiCalls/archivalApiCalls";

export default function DprRecord({ project }) {
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const [dprData, setDprData] = useState([]);
  const [filterData, setFilterData] = useState({
    StartDate: "",
    EndDate: "",
    DPRName: "",
    DPRType: "",
    DateRange: "",
    sortOrder: "ASC",
    sortBy: "Site Vist/Audit Date",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(dprData.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = dprData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const fetchArchivalDpr = async (payload) => {
    let obj = payload;
    if (!payload) {
      obj = {
        ProjectID: project.project_id,
      };
    }
    const response = await PROJECT_ARCHIVAL.getDPRDetails(obj);
    if (response && response.DPRList.length > 0) {
      setDprData(response.DPRList);
    } else {
      setDprData([]);
    }
  };
  useEffect(() => {
    fetchArchivalDpr();
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <React.Fragment>
      <Modal open={open} onClose={() => {}} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">DPR Filter</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpen(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="card mt-0 card-bd-none">
            <div className="card-body">
              <div className="row">
                <div className="col-6">
                  <label className="filter-label">Start date</label>
                  <input
                    type="date"
                    name="StartDate"
                    value={filterData.StartDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">End date</label>
                  <input
                    type="date"
                    name="EndDate"
                    value={filterData.EndDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Dpr Name</label>
                  <input
                    type="text"
                    name="DPRName"
                    value={filterData.DPRName}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">Recently Added Dpr</label>
                  <select
                    name="DateRange"
                    value={filterData.DateRange}
                    onChange={handleChange}
                    className="filter-label"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option value="1-month">1 Month</option>
                    <option value="2-month">2 Month</option>
                  </select>
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-12">
                  <label className="filter-label">Dpr Type</label>
                  <select
                    name="DPRType"
                    value={filterData.DPRType}
                    onChange={handleChange}
                    className="filter-label"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option value=""></option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-center mt-4 pb-4">
          <button
            onClick={(e) => {
              fetchArchivalDpr(filterData);
              setOpen(false);
              setCurrentPage(1);
            }}
            className="btn btn-primary"
          >
            Filter
          </button>
        </div>
      </Modal>
      <div className="row">
        <div className="d-flex justify-content-end">
          <div className="download-icon">
            <ExcelExport data={dprData} fileName="Dpr" sheet="Dpr List" />
          </div>
          <div className="filter-icon mx-2 my-auto">
            <img
              className=""
              onClick={() => {
                setOpen(true);
              }}
              src={Filter}
              width={20}
            />
          </div>
          <div className="my-auto" onClick={() => fetchArchivalDpr()}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 12,
                fontWeight: 500,
                background: "#8add79f7",
                padding: 5,
                borderRadius: 12,
              }}
            >
              Clear filters
            </span>
          </div>
        </div>
      </div>
      <div className="table-container-archival">
        <table id="custom-table-archival">
          <thead className="table-header-archival">
            <tr>
              <th>Sr No</th>
              {/* <th>Project Name</th>
              <th>Project ID</th>
              <th>Region</th>
              <th>Location</th>
              <th>Client</th>
              <th>Product Category</th>
              <th>Project Status</th> */}
              <th>Dpr Name</th>
              <th>Work Package</th>
              <th style={{ whiteSpace: "nowrap" }}>Progress %</th>
              <th>Created Date</th>
              <th>Cumulative</th>
              <th>Balance Scope</th>
              <th>Weighted Progress</th>
              <th>Weather</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, index) => (
              <tr key={index}>
                <td>
                  <td>{index + 1 + (currentPage - 1) * 10}</td>
                </td>
                {/* <td>{project.Project_Name}</td>
                <td>{project.project_id}</td>
                <td>{project.Region}</td>
                <td>{project.Location}</td>
                <td>-</td>
                <td>{project.Product_Category}</td>
                <td>{project.ProjectStatus}</td> */}
                <td>{row.Subtask}</td>
                <td style={{ whiteSpace: "nowrap" }}>{row.WorkPackage}</td>
                <td>{row.ProgressPercentage}</td>
                <td>{new Date(row?.CreatedOn).toLocaleDateString('en-GB')}</td>
                <td>{row.Cumulative}</td>
                <td>{row.BalanceScope}</td>
                <td>{row.WeightedProgress}</td>
                <td>-</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        className="pagination"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 15px",
        }}
      >
        <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
          Showing{" "}
          {Math.min((currentPage - 1) * rowsPerPage + 1, dprData.length)} to{" "}
          {Math.min(currentPage * rowsPerPage, dprData.length)} of{" "}
          {dprData.length} entries
        </div>

        <div
          className="pagination-buttons"
          style={{
            fontSize: "14px",
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            gap: "5px",
          }}
        >
          {/* Left Arrow */}
          <button
            onClick={() => handleClick(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={leftArrow} // Replace with your actual image path
              alt="Previous"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
            />
          </button>

          {/* Page Numbers */}
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              onClick={() => handleClick(i + 1)}
              style={{
                background: currentPage === i + 1 ? "#00B69B" : "transparent",
                color: currentPage === i + 1 ? "#fff" : "#000",
                border: "none",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              {i + 1}
            </button>
          ))}

          {/* Right Arrow */}
          <button
            onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={rightArrow} // Replace with your actual image path
              alt="Next"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
            />
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}
